import { useContext, useEffect, useState } from 'react'
import { UIContext } from 'Context/UI'

const ViewModel = () => {
	const { setShowContentToolbar, setCustomContentToolbar } = useContext(UIContext)
	const [currentActivePlan, setCurrentActivePlan] = useState(0)
	const [openPlanDetailModal, setOpenPlanDetailModal] = useState(false)

	const onPlanClick = (idx: number) => {
		setCurrentActivePlan(idx)
	}

	const handleOpenPlanDetailModal = () => {
		setOpenPlanDetailModal(true)
	}

	const handleClosePlanDetailModal = () => {
		setOpenPlanDetailModal(false)
	}

	useEffect(() => {
		setShowContentToolbar(false)
		setCustomContentToolbar(null)

		return () => {
			setShowContentToolbar(true)
			setCustomContentToolbar(null)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	return {
		currentActivePlan,
		onPlanClick,
		openPlanDetailModal,
		handleOpenPlanDetailModal,
		handleClosePlanDetailModal,
	}
}

export default ViewModel
